function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import c from 'classnames';
var AccordionItemVariant = function AccordionItemVariant(_ref) {
  var title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    buttonOpened = _ref.buttonOpened,
    buttonClosed = _ref.buttonClosed,
    duration = _ref.duration,
    easing = _ref.easing,
    onClick = _ref.onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggleAccordion = _useState2[0],
    setToggleAccordion = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var toggle = function toggle() {
    setToggleAccordion(!toggleAccordion);
    setHeight(height === 0 ? 'auto' : 0);
    if (onClick) {
      onClick();
    }
  };
  var AccordionItem = c('AccordionItem', className, toggleAccordion === true ? 'AccordionItem--active' : 'AccordionItem--inactive');
  return /*#__PURE__*/React.createElement("div", {
    className: AccordionItem
  }, /*#__PURE__*/React.createElement("div", {
    onClick: toggle,
    className: "AccordionItem__title__wrapper"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "AccordionItem__title"
  }, title), toggleAccordion === true ? /*#__PURE__*/React.createElement("div", null, buttonOpened) : /*#__PURE__*/React.createElement("div", null, buttonClosed)), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: duration,
    easing: easing,
    height: height
  }, children));
};
AccordionItemVariant.defaultProps = {
  title: 'Default title',
  className: 'AccordionItemCustomClass',
  children: /*#__PURE__*/React.createElement("div", null, "Default answer"),
  buttonOpened: /*#__PURE__*/React.createElement("div", null, "close"),
  buttonClosed: /*#__PURE__*/React.createElement("div", null, "open"),
  duration: 333,
  easing: 'cubic-bezier(0, 0, .2, 1)'
};
export default AccordionItemVariant;